"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _BaseComponents = require("../../../components/StyledComponents/BaseComponents");
var _services = require("../../../services");
var _constants = require("../../constants");
var _RecommendationSummaryParser = require("../generic/RecommendationSummaryParser");
/**
 * A parser for the Peru recommendation summary.
 */
class PeruRecommendationSummaryParser extends _RecommendationSummaryParser.RecommendationSummaryParser {
  /**
   * Creates an instance of PeruRecommendationSummaryParser.
   * @param props - The props for the parser.
   */
  constructor(props) {
    super(props);
  }
  getDiscountAmount() {
    return Math.round(100 * (1 - this.totalTermCostAfterDiscount / this.totalTermCost));
  }
  calculateHideDiscount() {
    var _this$metadata, _this$metadata$flags;
    const discountedAmount = this.getDiscountAmount();
    return !((_this$metadata = this.metadata) !== null && _this$metadata !== void 0 && (_this$metadata$flags = _this$metadata.flags) !== null && _this$metadata$flags !== void 0 && _this$metadata$flags[_constants.FLAGS.PLAN_PORT_LINE]) || super.calculateHideDiscount() || discountedAmount < this.minimumDiscount;
  }
  productTermCostAfterDiscountByProduct(product) {
    return _services.Services.locale.formatPrice(product.termCostAfterDiscount && !this.calculateHideDiscount() ? product.termCostAfterDiscount : product.termCost);
  }

  /**
   * Calculates the total term cost based on  totalTermCostBeforeDiscount being defined
   * @returns The total term cost.
   */
  get totalTermCostText() {
    return _services.Services.locale.formatPrice(this.totalTermCostAfterDiscount && !this.calculateHideDiscount() ? this.totalTermCostAfterDiscount : this.totalTermCost);
  }

  /**
   * Gets the wrapper component for the recommendation summary section.
   * @returns The wrapper component reference. Fragment for large screens, FlexItem for small screens.
   */
  get WrapperComponent() {
    return this.isSmallScreen ? _BaseComponents.FlexItem : _react.Fragment;
  }
}
var _default = PeruRecommendationSummaryParser;
exports.default = _default;